import React from "react";
import Text from "./Text";

type CardSolutionProps = React.ComponentPropsWithoutRef<"div"> & {
  title: string;
  description: string;
  imageSrc: string;
  width?: Array<string>;
};

const CardSolution: React.FC<CardSolutionProps> = (props) => {
  const {
    title,
    description,
    imageSrc,
    width = ["auto", "344px"],
    ...restProps
  } = props;

  return (
    <React.Fragment>
      <div className="card-solution" {...restProps}>
        <div className={"card-solution__overlay"} />
        <img src={imageSrc} alt={title} />
        <div className="card-solution__body">
          <Text
            fontFamily={["Lexend", "Roboto"]}
            fontSize={["16px", "20px"]}
            fontWeight={["700", "700"]}
            lineHeight={["24px", "24px"]}
            textAlign={["left", "center"]}
            color={["#383838", "#D9D9D9"]}
          >
            {title}
          </Text>
          <Text
            fontFamily={["Lexend", "Lexend"]}
            fontSize={["14px", "16px"]}
            fontWeight={["400", "400"]}
            lineHeight={["18px", "21px"]}
            textAlign={["left", "center"]}
            color={["#383838", "#D9D9D9"]}
          >
            {description}
          </Text>
        </div>
      </div>
      <style jsx scoped>{`
        .card-solution {
          position: relative;
          display: flex;
          flex-direction: column;
          border-radius: 8px;
          width: ${width[0]};
          border-radius: 16px;
          border: 1px solid #d1d1d1;
          overflow: hidden;
        }

        .card-solution img {
          width: 100%;
          height: auto;
          overflow: hidden;
          border-top-left-radius: 16px;
          border-top-right-radius: 16px;
        }

        .card-solution .card-solution__overlay {
          display: none;
          overflow: hidden;

          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          z-index: 1;
          background: linear-gradient(
            180deg,
            rgba(20, 20, 20, 0.16) 0%,
            rgba(0, 0, 0, 0.8) 100%
          );
        }

        .card-solution__body {
          display: flex;
          flex-direction: column;
          padding: 16px;
          gap: 16px;
          background-color: #ffffff;
        }

        @media only screen and (min-width: 480px) {
          .card-solution {
            width: ${width[1]};
            border: none;
          }

          .card-solution img {
            width: 100%;
            height: auto;
            overflow: hidden;
            border-top-left-radius: 16px;
            border-top-right-radius: 16px;
            border-radius: 16px;
          }

          .card-solution .card-solution__overlay {
            display: block;
            border-radius: 16px;
          }

          .card-solution__body {
            position: absolute;
            bottom: 0;
            z-index: 1;
            width: auto;
            gap: 0;
            background-color: transparent;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default CardSolution;
